import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'  
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import authService from './auth/oidc';
//import vuetify from './plugins/vuetify';
import VueViewer from 'v-viewer';
import moment from 'moment';
import axios from 'axios';
import Swal from 'sweetalert2';
import JSEncrypt from 'jsencrypt';
import { SHA256 } from 'crypto-js';
import Cookies from 'js-cookie';
import 'viewerjs/dist/viewer.css';
import 'swiper/swiper-bundle.css';
import 'moment/locale/pt-br'; 
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
import { loading } from './loading';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import TheMask from 'vue-the-mask';
import CKEditor from '@ckeditor/ckeditor5-vue';
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',      // diz pro Vuetify usar MDI como padrão
  },
})

SwiperCore.use([Navigation, Pagination]);

const decimalDirective = {
  beforeMount(el, binding) {
    const input = el.querySelector('input') || el;

    input.addEventListener('input', () => {
      let value = input.value;

      // Remover todos os caracteres não numéricos, exceto ponto e vírgula
      value = value.replace(/[^\d,]/g, '');

      // Se houver mais de uma vírgula, remove a extra
      const parts = value.split(',');
      if (parts.length > 2) {
        parts[1] = parts.slice(1).join('');
        value = parts.join(',');
      }

      // Limitar a 2 casas decimais após a vírgula
      if (parts[1] && parts[1].length > 2) {
        value = `${parts[0]},${parts[1].substring(0, 2)}`;
      }

      input.value = value;

      // Converter vírgula para ponto para o v-model (back-end usa ponto)
      const numericValue = parseFloat(value.replace(',', '.')) || null;
      binding.instance[binding.arg] = numericValue;
    });

    input.addEventListener('blur', () => {
      let value = input.value;

      // Formatar o valor para duas casas decimais ao perder o foco
      let numericValue = parseFloat(value.replace(',', '.'));
      if (!isNaN(numericValue)) {
        input.value = numericValue.toFixed(2).replace('.', ','); // Mostrar com vírgula
        binding.instance[binding.arg] = numericValue;
      } else {
        input.value = '';
        binding.instance[binding.arg] = null;
      }
    });
  }
};

const app = createApp(App)

app.use(router)
app.use(vuetify)
app.use(VueViewer)
app.use(TheMask)
app.use(CKEditor)
app.directive('decimal', decimalDirective);

app.config.globalProperties.$ckconfig = {
  toolbar: ['selectAll','heading', '|', 'bold', 'italic','strikethrough', 'underline','|', 'fontSize','fontFamily', 'link','|', 'fontColor', 'fontBackgroundColor', 'bulletedList', 'numberedList', 'blockQuote','alignment', 'insertTable', '|'],
  heading: {
    options: [
        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
    ]
},
fontFamily: {
  options: [
      'default',
      'Arial, Helvetica, sans-serif',
      'Courier New, Courier, monospace',
      'Georgia, serif',
      'Lucida Sans Unicode, Lucida Grande, sans-serif',
      'Tahoma, Geneva, sans-serif',
      'Times New Roman, Times, serif',
      'Trebuchet MS, Helvetica, sans-serif',
      'Verdana, Geneva, sans-serif'
  ],
  supportAllValues: true
},
fontSize: {
  options: [ 10, 12, 14, 'default', 18, 20, 22,25,30,50,60 ],
  supportAllValues: true
},
}

app.component('EasyDataTable', Vue3EasyDataTable);

app.config.globalProperties.$loading = loading; 

//dados GarantePay homolog
app.config.globalProperties.$GarantePayNome = "GarantePay";
app.config.globalProperties.$GarantePayAstenEmail = "suporte@garantepay.com.br";
//app.config.globalProperties.$GarantePayAstenEmail = "contato@avancedigital.com.br";
app.config.globalProperties.$GarantePayEmail = "suporte@garantepay.com.br";
app.config.globalProperties.$GarantePayLinkAcesso = "https://garantepay.net.br/";
app.config.globalProperties.$GarantePayLinkAcessoAsten = "https://plataforma.astenassinatura.com.br/login/GARANTEPAY";
app.config.globalProperties.$DadosCompraManual = "GarantePayContratacao"

app.config.globalProperties.$scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

app.config.globalProperties.$moment = moment

//homolog
//app.config.globalProperties.$imgURL = 'http://garantepay.kinghost.net/imagensProducao/'
//axios.defaults.baseURL = 'http://controle.garantepay.kinghost.net/api'
app.config.globalProperties.$imgURL = '/api/ProcessAPI'
axios.defaults.baseURL = '/api/ProcessAPI'
axios.defaults.withCredentials = false

app.config.globalProperties.$mensagemSucesso = function (mensagem) {
  Swal.fire(' ', mensagem, 'success')
}
app.config.globalProperties.$mensagemErro = function (mensagem) {
  Swal.fire(' ', mensagem, 'error')
}
app.config.globalProperties.$mensagemAviso = function (mensagem) {
  Swal.fire({
    position: 'top-end',
    icon: 'warning',
    title: mensagem,
    showConfirmButton: false,
    timer: 5000 // Tempo em milissegundos (3 segundos neste exemplo)
  })
}


app.config.globalProperties.$mensagemAvisoConfirm = function (mensagem) {
  Swal.fire({
    position: 'top-end',
    icon: 'warning',
    title: mensagem,
    showConfirmButton: true,

  })
}

app.config.globalProperties.$mensagemAvisoSucesso = function (mensagem) {
  Swal.fire({
    position: 'top-end',
    icon: 'success',
    title: mensagem,
    showConfirmButton: false,
    timer: 2000 // Tempo em milissegundos (3 segundos neste exemplo)
  })
}

app.config.globalProperties.$mensagemConfirma = function (mensagem) {
  return Swal.fire({
    icon: 'warning',
    title: mensagem,
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true
  });
};

app.config.globalProperties.$mensagemSimNao = function (mensagem) {
  return Swal.fire({
    icon: 'warning',
    title: mensagem,
    showCancelButton: true,
    confirmButtonText: 'Sim',
    cancelButtonText: 'Não',
    reverseButtons: true
  });
};

// Criptografe os dados desejados
app.config.globalProperties.$axios = axios

axios.interceptors.request.use(async (config) => {
  // Configurações adicionais antes de fazer a chamada à API
  app.config.globalProperties.$loading.value = true; // Definir o estado do loader como true
  const accessToken = await authService.getAccessToken()
  if (accessToken) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  return config;
});

async function redirectToLogin() {
  // Mensagem (opcional)
  //app.config.globalProperties.$mensagemErro?.('Sessão expirada. Faça login novamente.')

 const current = router.currentRoute.value
  // Evita redirecionar se já estiver no login
  if (
    current?.name !== 'login' &&
    current?.name !== 'AuthCallback' &&
    current?.name !== 'AuthCallbackShort' &&
    current?.path !== '/login'
  ) {
    await authService.clearAuthState()
    await authService.signInRedirect(current?.fullPath ?? '/Home')
  }
}

axios.interceptors.response.use(
  (response) => {
    app.config.globalProperties.$loading.value = false
    return response
  },
  (error) => {
    app.config.globalProperties.$loading.value = false

    const status = error?.response?.status
    if ((status === 401 || status === 405 || status === 403) && !error?.config?.skipAuthRedirect) {
      redirectToLogin().catch(() => {
        router.push({
          name: 'login',
          query: { redirect: router.currentRoute.value?.fullPath ?? '/Home' }
        }).catch(() => {})
      })
      return Promise.reject(error)
    }

    if (error?.code === 'ERR_NETWORK') {
      app.config.globalProperties.$mensagemErro('Sistema fora do ar.' + error)
    } else if (error?.response?.data?.message) {
      app.config.globalProperties.$mensagemErro(error.response.data.message)
    } else {
      app.config.globalProperties.$mensagemErro('Falha ao conectar, contate o administrador.')
    }
    return Promise.reject(error)
  }
)

router.isReady().then(() => {
  app.mount('#app')
})
